export const SIGNIN = 'SIGNIN';
export const SIGNIN_FULFILLED = 'SIGNIN_FULFILLED';
export const SIGNOUT = 'SIGNOUT';
